module.exports = __webpack_public_path__ + "img/9U.97b97428.png";